import ReactDom from 'react-dom';
import App from './App';
import './index.css';

import './i18nextconfig';

ReactDom.render(<App/>, document.getElementById("root"));